<template>
<div>
    <section id="summary" class="container">
      <div class="segment box">
        <h1 class="title is-uppercase has-text-centered">Gamesheet</h1>
        <h2 class="subtitle has-text-centered">{{ this.teamName }}</h2>
        <div class="small-box">
        <h2 class="subtitle">Forwards</h2>
        <sort-table endpoint="https://devilsapi.roblutken.com/api/app/gamesheet-away-only"
          :postData="[{
          team_id: this.teamId,
          game_id: this.gameId,
          position: 'forward'
          }]"
          :selectedData="[
              {
                title: 'player',
                prop: 'player'
              },
              {
                title: 'Shifts',
                prop: 'toi_shifts'
              },
              {
                title: 'AVG Shift',
                prop: 'toi_avg_shifts'
              },
              {
                title: 'EH',
                prop: 'toi_eh'
              },
              {
                title: 'PP',
                prop: 'toi_pp'
              },
              {
                title: 'SH',
                prop: 'toi_sh'
              },
              {
                title: 'Total TOI',
                prop: 'toi_total'
              }
          ]"  @dataLoaded="gameDataLoaded">
        </sort-table>
        <h2 class="subtitle">Defense</h2>
        <sort-table endpoint="https://devilsapi.roblutken.com/api/app/gamesheet-away-only"
          :postData="[{
          team_id: this.teamId,
          game_id: this.gameId,
          position: 'defense'
          }]"
          :selectedData="[
              {
                title: 'player',
                prop: 'player'
              },
              {
                title: 'Shifts',
                prop: 'toi_shifts'
              },
              {
                title: 'AVG Shift',
                prop: 'toi_avg_shifts'
              },
              {
                title: 'EH',
                prop: 'toi_eh'
              },
              {
                title: 'PP',
                prop: 'toi_pp'
              },
              {
                title: 'SH',
                prop: 'toi_sh'
              },
              {
                title: 'Total TOI',
                prop: 'toi_total'
              }
          ]"  @dataLoaded="gameDataLoaded">
        </sort-table>
        <h2 class="subtitle">Goaltending</h2>
        <sort-table endpoint="https://devilsapi.roblutken.com/api/app/gamesheet-away-only"
          :postData="[{
          team_id: this.teamId,
          game_id: this.gameId,
          position: 'goaltender'
          }]"
          :selectedData="[
              {
                title: 'player',
                prop: 'player'
              },
              {
                title: 'Shifts',
                prop: 'toi_shifts'
              },
              {
                title: 'AVG Shift',
                prop: 'toi_avg_shifts'
              },
              {
                title: 'EH',
                prop: 'toi_eh'
              },
              {
                title: 'PP',
                prop: 'toi_pp'
              },
              {
                title: 'SH',
                prop: 'toi_sh'
              },
              {
                title: 'Total TOI',
                prop: 'toi_total'
              }
          ]"  @dataLoaded="gameDataLoaded">
        </sort-table>
        </div>
      </div>
    </section>
</div>
</template>

<script>
import SortTable from './sort-table'
export default {
  props: {
    gameId: { type: Number, required: true },
    period: { type: Number, required: true },
    team: {type: Number, required: true},
    // Object with a default value
    gameInfo: {
      type: Object,
      // Object or array defaults must be returned from
      // a factory function. The function receives the raw
      // props received by the component as the argument.
      default (rawProps) {
        return { }
      }
    }
  },
  data: function () {
    return {
      teamId: 0,
      teamName: 0
    }
  },
  components: {
    SortTable
  },
  methods: {
    gameDataLoaded () {
      // console.log('Loaded')
      if (this.team === 0) {
        this.teamId = this.gameInfo.home_team.id
        this.teamName = this.gameInfo.home_team.name
      } else {
        this.teamId = this.gameInfo.away_team.id
        this.teamName = this.gameInfo.away_team.name
      }
      console.log('Prop value: ' + this.team + ' teamId Set: ' + this.teamId + ' Home: ' + this.gameInfo.home_team.id + ' Away: ' + this.gameInfo.away_team.id)
      console.log(JSON.stringify(this.gameInfo))
    },
    filterChange () {
      // console.log('Filter update: ' + this.PenaltySelected)
    }
  },
  mounted: function () {
    console.log('Game Id: ' + this.gameId)
  }
}
</script>

<style lang='scss' scoped>

.segment {
  padding-top:1em;
  padding-bottom:2em;
  margin-right: auto;
  margin-left:auto;
  max-width: 98%;
  margin-top:1em;
  padding-left: 1em;
  padding-right: 1em;
  -webkit-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  -moz-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
}
.small-box {
  padding-top:1em;
  padding-bottom:2em;
  margin-right: auto;
  margin-left:auto;
  max-width: 100%;
  margin-top:1em;
  padding-left: 1em;
  padding-right: 1em;
  -webkit-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  -moz-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
}
.segment h1 {
  color:rgb(39, 39, 39);
  margin-top:0.4em;
  font-weight: 800;
  text-transform: uppercase;
  font-size: 3em;
}
.segment h2 {
  color:rgb(39, 39, 39);
  margin-top:0.4em;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 2em;
}
.segment p{
  font-size:1.2em;
  text-transform: uppercase;
}
.stat-title{
  font-family: 'Heebo', sans-serif;
  font-weight: 100;
  text-transform: capitalize;
  color:rgb(29, 29, 29);
  font-size: 1.3rem;
  margin: 1rem 0rem;
}
.stat-category{
  font-family: 'Heebo', sans-serif;
  font-weight: 100;
  text-transform: capitalize;
  color:rgb(29, 29, 29);
  font-size: 1.5rem;
  margin: 1rem 0rem;
}
.stat-number{
  font-family: 'Heebo', sans-serif;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 1.3rem;
  margin: 1rem 0rem;
  color:black;
}
</style>



// WEBPACK FOOTER //
// gamesheet-dynamic.vue?799d46fc